import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getICYMIPosts } from "../../redux/features/post/postSlice";
import "./Icymi.scss";
import { Link } from "react-router-dom";

const Icymi = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getICYMIPosts());
  }, [dispatch]);

  const { icymiPosts } = useSelector((state) => state.post);

  const icymi = icymiPosts
    ?.filter((post) => {
      return post;
    })
    ?.filter((post, index) => index < 5);
  return (
    <section className="icymi-section">
      <h2>In Case You Missed It</h2>

      <div className="left-content">
        <img
          src={icymiPosts[0]?.image || "/default.jpg"}
          alt={icymiPosts[0]?.title}
        />
        <div className="caption">{icymiPosts[0]?.title}</div>
      </div>

      <div className="right-content">
        <ul>
          {icymi.map((post) => (
            <li key={post._id}>
              <Link to={`/page/${post.slug}`}>{post.title}</Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
export default Icymi;
